"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var react_spring_1 = require("react-spring");
var react_acdc_1 = require("@seaweb/react-acdc");
var ThemeProvider_1 = require("@seaweb/coral/components/ThemeProvider");
var Popper_1 = require("@seaweb/coral/components/Popper");
var Elevator_1 = require("@seaweb/coral/components/Elevator");
var color_1 = require("@seaweb/coral/utils/color");
var useForkRef_1 = __importDefault(require("@seaweb/coral/hooks/useForkRef"));
var getRoot_1 = __importStar(require("@seaweb/coral/utils/getRoot"));
var internals_1 = require("./internals");
var SelectScrollerUList = styled_1.default.ul(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  max-height: 300px;\n  overflow-y: auto;\n  list-style-type: none;\n  z-index: 101;\n  margin: 0;\n  will-change: transform;\n\n  &:focus {\n    outline: none;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  max-height: 300px;\n  overflow-y: auto;\n  list-style-type: none;\n  z-index: 101;\n  margin: 0;\n  will-change: transform;\n\n  &:focus {\n    outline: none;\n  }\n\n  ",
    "\n\n  ",
    "\n\n  ",
    "\n\n  ",
    "\n"])), function (_a) {
    var _immediate = _a._immediate;
    return !_immediate && styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      transition: visibility 0.3s;\n    "], ["\n      transition: visibility 0.3s;\n    "])));
}, function (_a) {
    var _b = _a.theme, spacing = _b.spacing, colors = _b.colors;
    return styled_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border-radius: ", "px;\n    padding: ", "px 0;\n    box-shadow: 0 5px 20px 0 ", ";\n    border: solid 1px ", ";\n    background-color: ", ";\n    color: ", ";\n  "], ["\n    border-radius: ", "px;\n    padding: ", "px 0;\n    box-shadow: 0 5px 20px 0 ", ";\n    border: solid 1px ", ";\n    background-color: ", ";\n    color: ", ";\n  "])), spacing.radius, spacing.factor, color_1.alp(colors.alternate, 0.05), colors.border, color_1.lit(colors.plain, 3), colors.alternate);
}, function (_a) {
    var _width = _a._width, _zindex = _a._zindex;
    return styled_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: ", "px;\n    z-index: ", ";\n  "], ["\n    width: ", "px;\n    z-index: ", ";\n  "])), _width, _zindex);
}, function (_a) {
    var _isOpen = _a._isOpen;
    return !_isOpen && styled_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      visibility: hidden;\n      pointer-events: none;\n    "], ["\n      visibility: hidden;\n      pointer-events: none;\n    "])));
});
var AnimatedSelectScrollerUList = react_spring_1.animated(SelectScrollerUList);
var SelectScroller = react_1.forwardRef(function SelectScroller(_a, ref) {
    var as = _a.as, _b = _a.placement, placement = _b === void 0 ? Popper_1.Placements.Bottom : _b, popperUpdateKey = _a.popperUpdateKey, popperReference = _a.popperReference, _c = _a.width, widthProp = _c === void 0 ? 'auto' : _c, immediate = _a.immediate, _d = _a.container, container = _d === void 0 ? (getRoot_1.warnSSR('SelectList', 'container'), getRoot_1.default()) : _d, style = _a.style, props = __rest(_a, ["as", "placement", "popperUpdateKey", "popperReference", "width", "immediate", "container", "style"]);
    var isOpen = react_acdc_1.useAcdcContext().state.isOpen;
    var _e = Popper_1.usePopperPopper({
        referenceElement: popperReference,
        placement: placement,
        eventsEnabled: isOpen,
        offset: [0, 1],
    }), popperRef = _e.popperRef, forceUpdate = _e.forceUpdate, styles = _e.styles, attributes = _e.attributes;
    var handleRef = useForkRef_1.default(ref, popperRef);
    react_1.useEffect(function () {
        if (forceUpdate)
            forceUpdate();
    }, [forceUpdate, popperUpdateKey]);
    var factor = ThemeProvider_1.useThemeContext().spacing.factor;
    var spring = react_spring_1.useSpring({
        opacity: isOpen ? 1 : 0,
        offset: isOpen ? 0 : -3 * factor,
        config: { tension: 600, mass: 0.8 },
        immediate: immediate,
    });
    var transform = react_spring_1.interpolate(spring.offset, function (offset) { return styles.popper.transform + " translateY(" + offset + "px)"; });
    var width = internals_1.useSelectListWidth(widthProp);
    var zIndex = Elevator_1.useElevation(1);
    var el = (react_1.default.createElement(AnimatedSelectScrollerUList, __assign({ as: as, ref: handleRef, immediate: immediate, style: __assign(__assign(__assign({}, styles.popper), { transform: transform, opacity: spring.opacity }), style), _width: width, _isOpen: isOpen, _zindex: zIndex }, attributes.popper, props)));
    return container !== null ? react_dom_1.createPortal(el, container) : el;
});
exports.default = SelectScroller;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
